import { Components } from "@thisgorilla/primate-ds";
import { useContext } from "react";
import { useTheme } from "styled-components";
import { CenterPanelContext } from "../..";
import {
  actions,
  useAppDispatch,
  useAppSelector,
} from "../../../../../../redux";
import { FlexColumn, FlexRow } from "../../../../../Common/Styles";
import NewsFeedFilterProps from "../NewsFeedFilter";
import { Container, EmptyCircleContainer, ScrollContainer } from "./style";

const List = ({
  setStepKey,
  setCircleListOpen,
}: NewsFeedFilterProps.ListProps) => {
  const dispatch = useAppDispatch();
  const { typography, Color } = useTheme();
  const { listOfCircles } = useAppSelector((state) => state.circle);
  const { selectedCircle, setSelectedCircle } = useContext(CenterPanelContext);
  return (
    <FlexColumn $gapInPx={8}>
      <Components.ListItem type="Label" label="Filter by Circle" />
      <Components.ListItem type="Divider" />
      <Container>
        <Components.Text
          style={{ tokenStyle: typography.Body.S }}
          text="Circles"
          color={Color.text["text-emphasize-brand-bolder"].value}
          fontWeight="font-weight-semibold"
          lineHeight="line-height-75"
        />
        {listOfCircles.length > 0 ? (
          <ScrollContainer>
            {listOfCircles.map((circle) => (
              <Components.ListItem
                key={circle.id}
                type="Circle"
                color={circle.colour}
                label={circle.name}
                selected={
                  selectedCircle.findIndex((c) => c.id === circle.id) !== -1
                }
                onClick={() => {
                  if (
                    selectedCircle.findIndex((c) => c.id === circle.id) === -1
                  ) {
                    setSelectedCircle([...selectedCircle, circle]);
                  } else {
                    setSelectedCircle(
                      selectedCircle.filter((c) => c.id !== circle.id)
                    );
                  }
                  dispatch(actions.newsfeed.setPage(1));
                }}
                rightNode={
                  <FlexRow $gapInPx={2}>
                    <Components.IconButton
                      disabled={false}
                      kind="Tertiary"
                      onClick={(e) => {
                        e.stopPropagation();
                        dispatch(
                          actions.circle.setCreateCircleOpen({
                            createCircleOpen: true,
                            editCircleId: circle.id,
                          })
                        );
                      }}
                      size="XXS"
                      iconType="Edit"
                    />
                    <Components.IconButton
                      disabled={false}
                      kind="Tertiary"
                      onClick={(e) => {
                        e.stopPropagation();
                        setStepKey(circle.id);
                      }}
                      size="XXS"
                      iconType="Trash2"
                    />
                  </FlexRow>
                }
              />
            ))}
          </ScrollContainer>
        ) : (
          <EmptyCircleContainer $gapInPx={8}>
            <Components.Icon
              type="Info"
              color={Color.icon["icon-brand-bolder"].value}
              size="16px"
            />
            <Components.Text
              style={{ tokenStyle: typography.Body.M }}
              text="Looks like you don’t have any Circles yet. Let creat one!"
              color={Color.text["text-emphasize-brand-bolder"].value}
            />
          </EmptyCircleContainer>
        )}
      </Container>
      <Components.ListItem
        type="Button"
        IconType="Plus"
        label="Create a Circle"
        onClick={() => {
          dispatch(
            actions.circle.setCreateCircleOpen({
              createCircleOpen: true,
            })
          );
          setCircleListOpen(false);
        }}
      />
    </FlexColumn>
  );
};

export default List;
